export enum ScheduleBlockType {
    Appointments = 1,
    Lunch = 2,
    Surgery = 3,
    Meeting = 4,
    Notes = 5,
    Event = 6,
    HolidayPTO = 7,
    Training = 8,
    Technician_Appointments = 9,
    Vaccine_Appointment = 10
}
